import React from "react";
import { Github } from "@ucloud/ucloud-icons/dist/www/svgr";
import { OAuthListWrapper } from "./style.jsx";
import localeService from "../../../service/localeService.js";
import { isChannelKeyEffect } from "../../../common/channel.js"


const OAuthGithub = ({ type = "Login", bindChange }) => {
    // const query = new URLSearchParams(location.search);
    // const isShowgithub = query.get('github');
    // 和 UCloud 或 UCloud Global 域名相同的渠道入口不显示第三方注册
    if(isChannelKeyEffect()){
        return null;
    }

    // 测试用，判断是否展示github的按钮
    // if (isShowgithub !== '1') {
    //     return null;
    // }

    return (
        <OAuthListWrapper>
            {/* GitHub登录/注册 */}
            <div className='oauth-login-btn u-mb4' onClick={() => bindChange()}>
                <Github className='btn-logo' />
                <span className='btn-text'>
                    {localeService.getTranslate(type === "Login" ? "LOGINBYGITHUB" : "REGISTERBYGithub")}
                </span>
            </div>
        </OAuthListWrapper>
    );
};

export default OAuthGithub;



// WEBPACK FOOTER //
// src/pc/components/ThirdPartyOAuth/OAuthGithub.jsx